export default __webpack_public_path__ + "static/media/nenhum-registro.2d8f08d9.png";